// What an operator account sees (backend src/modules/operators/lib/operatorFeatures.ts); null means everything.
export type Feature =
  | 'dashboard'
  | 'members'
  | 'groups'
  | 'contacts'
  | 'analytics'
  | 'member360'
  | 'forms'
  | 'webinars'
  | 'duplicates'
  | 'messages'
  | 'programs'
  | 'committees'
  | 'events'
  | 'payments'
  | 'stipends'
  | 'fellowReview'
  | 'sync'
  | 'reports'
  | 'cihr';

export const canSee = (features: readonly string[] | null | undefined, feature: Feature) =>
  features === null || features === undefined || features.includes(feature);
